import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-page-l04 c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-page-l04__inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_TheK01Header = _resolveComponent("TheK01Header")!
  const _component_TextSanitized = _resolveComponent("TextSanitized")!
  const _component_theFooter = _resolveComponent("theFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheBreadcrumb),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TheK01Header, {
            title: _ctx.title,
            "published-at": _ctx.publishedAt,
            "updated-at": _ctx.updatedAt,
            "author-name": _ctx.authorName,
            "author-id": _ctx.authorId
          }, null, 8, ["title", "published-at", "updated-at", "author-name", "author-id"]),
          _createVNode(_component_TextSanitized, {
            text: _ctx.content,
            class: "p-the-page-l04__content"
          }, null, 8, ["text"])
        ])
      ])
    ]),
    _createVNode(_component_theFooter)
  ]))
}